import DoAPICall from './DoAPICall'

//Create complaint sub type
export async function createComplaintSubType(userToken, ComplaintSubType){
	const apiPayload = {
		httpMethod:'post',
		userToken,
		uri:'complaintsubtypes',
		payLoad:{
			complaint_type_id:ComplaintSubType.complaint_type_id,
			code:ComplaintSubType.code,
			name:ComplaintSubType.name,
			order:ComplaintSubType.order,
			requiresDetails:ComplaintSubType.requiresDetails,
			detailType:ComplaintSubType.detailType,
			prompt:ComplaintSubType.prompt
		},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All complaint sub type
export async function getComplaintSubTypes(userToken,complaintype_id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complaintsubtypes?complaint_type_id='+complaintype_id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get One complaint sub type
export async function getComplaintSubType(userToken, id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complaintsubtypes/'+id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Update complaint sub type
export async function updateComplaintSubType(userToken, ComplaintSubType){
	const apiPayload = {
		httpMethod:'put',
		userToken,
		uri:'complaintsubtypes/'+ComplaintSubType.id,
		payLoad:{
				complaint_type_id:ComplaintSubType.complaint_type_id,
				code:ComplaintSubType.code,
				name:ComplaintSubType.name,
				order:ComplaintSubType.order,
				requiresDetails:ComplaintSubType.requiresDetails,
				detailType:ComplaintSubType.detailType,
				prompt:ComplaintSubType.prompt
			},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Delete complaint sub type
export async function deleteComplaintSubType(userToken, id){
    const apiPayload = {
        httpMethod:'delete',
        userToken,
        uri:'complaintsubtypes/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}